import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule} from '@angular/http';
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AppHomePage } from '../pages/apphome/apphome';
import { RouterModule } from '@angular/router';
import { LoginPage} from '../pages/login/login';
import {SignUpPage} from '../pages/signup/signup'
import {OtpPage}  from '../pages/otp/otp';
//import {CategoryPage}  from '../pages/category/category';
import {ProductPage}  from '../pages/product/product';
import {MycartPage}  from '../pages/mycart/mycart';
import {OrderHistoryPage}  from '../pages/orderhistory/orderhistory';
import {ReferFriendsPage}  from '../pages/referfriends/referfriends';
import {KiloPointsPage}  from '../pages/kilopoints/kilopoints';
import {AboutUsPage}  from '../pages/aboutus/aboutus';
import {KiloMenuPage}  from '../pages/kilomenu/kilomenu';
import {KiloPartyPage}  from '../pages/kiloparty/kiloparty';
import {KiloStorePage}  from '../pages/kilostore/kilostore';
import {KilopartyProductPage}  from '../pages/kilopartyproduct/kilopartyproduct';
import {OrderPlacePage}  from '../pages/orderplace/orderplace';
import {ProfilePage} from '../pages/profile/profile';
import {DeliveryPage} from '../pages/delivery/delivery';
import {PaymentPage} from '../pages/payment/payment';
import {OrderDetailPage} from '../pages/orderdetail/orderdetail';
import {ProductviewPage} from '../pages/productview/productview';
import {InviteFriendPage} from '../pages/invitefriend/invitefriend';
import {InfoPage}  from '../pages/info/info';
//import {GooglePlaceModule} from "angular2-google-place"

@NgModule({
  declarations: [
  //AppComponent,
    MyApp,
    HomePage,
    ListPage,
	AppHomePage,
	LoginPage,
	SignUpPage,
	OtpPage,
	//CategoryPage,
	ProductPage,
	MycartPage,
	OrderHistoryPage,
	ReferFriendsPage,
	KiloPointsPage,
	AboutUsPage,
	KiloMenuPage,
	KiloPartyPage,
	KiloStorePage,
	KilopartyProductPage,
	OrderPlacePage,
	ProfilePage,
	DeliveryPage,
	PaymentPage,
	OrderDetailPage,
	ProductviewPage,
	InviteFriendPage,
	InfoPage
  ],
  imports: [
    BrowserModule,
	HttpModule,
//	GooglePlaceModule,
  IonicModule.forRoot(MyApp,{mode:'md'}),
 /* RouterModule.forRoot([
      {
		path:'login',
	component:LoginPage
	},
	{
		path:'signup',
	component:SignUpPage
	}
	])*/
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ListPage,
	AppHomePage,
	LoginPage,
	SignUpPage,
	OtpPage,
	//CategoryPage,
	ProductPage,
	MycartPage,
	OrderHistoryPage,
	ReferFriendsPage,
	KiloPointsPage,
	AboutUsPage,
	KiloMenuPage,
	KiloPartyPage,
	KiloStorePage,
	KilopartyProductPage,
	OrderPlacePage,
	ProfilePage,
	DeliveryPage,
	PaymentPage,
	OrderDetailPage,
	ProductviewPage,
	InviteFriendPage,
	InfoPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler}
  ]
})
export class AppModule {
	
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts